import { useParking } from 'src/providers/ParkingProvider';
import { Image, type ImageProps } from 'src/registry/ui/Image';

function formatPakingPath(imagePath: string, parkingId: string) {
    return `/sp-core/media/${parkingId}/${imagePath}`.replace(/\/\//g, '/');
}

/**
 * Wrapper for the Image component that adds the parking id to the base url so that it is routed correctly
 */
const ParkingImage = (props: ImageProps) => {
    const { parkingId } = useParking();

    const image = formatPakingPath(props.image || '', parkingId);

    return <Image {...props} image={image} />;
};

export default ParkingImage;
